import React from "react";
import { CustomList } from "components/index";
import { RenderProfile } from "components/render-profile";

const PerformanceReport = () => {
  const columns = [
    {
      header: "Employee",
      id: "id",
      accessorKey: "id",
      cell: ({ row }) => {
        const employee = row.original.employee;
        return <RenderProfile user={employee} />;
      },
    },
    {
      header: "Last FY grade",
      accessorKey: "previous_year.grade",
      id: "previous_year.grade",
      cell: ({ getValue }) => getValue()?.name,
    },
    {
      header: "Last FY Q1",
      accessorKey: "previous_year.q1",
      id: "previous_year.q1",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
    {
      header: "Last FY Q2",
      accessorKey: "previous_year.q2",
      id: "previous_year.q2",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
    {
      header: "Last FY Q3",
      accessorKey: "previous_year.q3",
      id: "previous_year.q3",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
    {
      header: "Last FY AVG",
      accessorKey: "previous_year.avg_score",
      id: "previous_year.avg_score",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
    {
      header: "Grade",
      accessorKey: "present_year.grade",
      id: "present_year.grade",
      cell: ({ getValue }) => getValue()?.name,
    },
    {
      header: "Q1",
      accessorKey: "present_year.q1",
      id: "present_year.q1",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
    {
      header: "Q2",
      accessorKey: "present_year.q2",
      id: "present_year.q2",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
    {
      header: "Q3",
      accessorKey: "present_year.q3",
      id: "present_year.q3",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
    {
      header: "AVG",
      accessorKey: "present_year.avg_score",
      id: "present_year.avg_score",
      cell: ({ getValue }) => getValue()?.toFixed(2),
      sortable: true,
    },
  ];
  return (
    <div className="flex-1 overflow-auto relative">
      <CustomList
        title={"Performance"}
        endPoint="performance-review/employee-report"
        columns={columns}
        showSearch={true}
        sortBy="name"
        sortOrder="asc"
        hidePagination={true}
        storageKey={`performance`}
      />
    </div>
  );
};

export default PerformanceReport;
